export default {
  assetsMaturity: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  assetsApproaching: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  exportTaxes: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  carteiraAdministrada: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
